import React from "react";
import Hero from "../components/Hero";
import OpportunitySection from "../components/OpportunitySection";
import StruggleSection from "../components/StruggleSection";
import LearnSection from "../components/LearnSection";
import PathsSection from "../components/PathsSection";
import CommunitySection from "../components/CommunitySection";
import ModulesSection from "../components/ModulesSection";
import PricingSection from "../components/PricingSection";
import MentorSection from "../components/MentorSection";
import GuaranteeSection from "../components/GuaranteeSection";
import FAQSection from "../components/FAQSection";
import FinalCTA from "../components/FinalCTA";
import Footer from "../components/Footer";
import Marquee from "../components/Marquee";
import { ArrowUp } from "lucide-react";

const Landing = () => {
  const scrollTop = () => window.scrollTo({ top: 0, behavior: "smooth" });
  return (
    <div id="topo">
      <Hero />
      <Marquee />
      <OpportunitySection />
      <StruggleSection />
      <LearnSection />
      <PathsSection />
      <CommunitySection />
      <ModulesSection />
      <PricingSection />
      <MentorSection />
      <GuaranteeSection />
      <FAQSection />
      <FinalCTA />
      <Footer />
      <div className="floating-back-top" onClick={scrollTop} aria-label="Voltar ao topo">
        <ArrowUp size={22} strokeWidth={2.5} />
      </div>
    </div>
  );
};

export default Landing;
